import React, { useLayoutEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  clearTicketFromItinerary,
  getTicketFromItinerary,
} from '../../../../../actions';
import Table from '../../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import { TICKET_PATH } from '../../../../../config/paths';
import { generateItineraryTicketColumns } from '../../../../../config/columns';

const ItineraryTicketTable = ({
  itineraryId,
  dispatchGetTicketFromItinerary,
  dispatchClearTicketFromItinerary,
  ticketList,
  loading,
}) => {
  useLayoutEffect(() => {
    dispatchGetTicketFromItinerary(itineraryId);
    return () => {
      dispatchClearTicketFromItinerary();
    };
  }, [itineraryId]);

  const sourceOptions = useMemo(
    () =>
      [
        ...new Map(
          ticketList.map(({ sourceLocation }) => [
            sourceLocation.id,
            sourceLocation,
          ]),
        ).values(),
      ].map(({ id, name }) => ({ value: id, label: name })),
    [ticketList],
  );

  const destinationOptions = useMemo(
    () =>
      [
        ...new Map(
          ticketList.map(({ destinationLocation }) => [
            destinationLocation.id,
            destinationLocation,
          ]),
        ).values(),
      ].map(({ id, name }) => ({ value: id, label: name })),
    [ticketList],
  );

  const columns = useMemo(
    () => generateItineraryTicketColumns(sourceOptions, destinationOptions),
    [sourceOptions, destinationOptions],
  );

  return (
    <Table
      data={ticketList}
      filterable
      loading={loading}
      columns={columns}
      manual={false}
      navigateToModelOnRowClick
      modelPath={TICKET_PATH}
      isExternalPath
      defaultFilterMethod={filterMethodCaseInsensitive}
      modelId="id"
      openPathInNewTab
    />
  );
};

ItineraryTicketTable.propTypes = {
  itineraryId: PropTypes.string.isRequired,
  dispatchGetTicketFromItinerary: PropTypes.func.isRequired,
  dispatchClearTicketFromItinerary: PropTypes.func.isRequired,
  ticketList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
};

ItineraryTicketTable.defaultProps = {};

const mapStateToProps = ({ ReservationUnit }) => ({
  ticketList: ReservationUnit.Ticket.getIn(['itinerary', 'content', 'content']),
  loading: ReservationUnit.Ticket.getIn(['itinerary', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetTicketFromItinerary: getTicketFromItinerary,
  dispatchClearTicketFromItinerary: clearTicketFromItinerary,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryTicketTable);
